// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ex1yJN {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.fpTWqp {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);
  border-top: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);
  border-right: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);
  border-bottom: var(--progress-item-border-width, 2px) solid transparent;
  border-left: var(--progress-item-border-width, 2px) solid transparent;
}

.plhPZ9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: var(--progress-item-border-width, 2px) solid transparent;
  border-top: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);
  border-right: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);
  animation: Y6Urqr var(--progress-item-animation-duration, 1s) linear infinite;
  opacity: 0;
}

/* Default variant - only shows background circle */
.fHy1hz .plhPZ9 {
  opacity: 0;
}

.fHy1hz .fpTWqp {
  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);
}

/* Active variant - shows spinning indicator */
.OT5R1V .plhPZ9 {
  opacity: 1;
}

.OT5R1V .fpTWqp {
  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);
}

/* Spinning animation */
@keyframes Y6Urqr {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProgressItem/ProgressItem.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6FAA6F;EAC7F,gGAAgG;EAChG,kGAAkG;EAClG,uEAAuE;EACvE,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gEAAgE;EAChE,gGAAgG;EAChG,kGAAkG;EAClG,6EAA2E;EAC3E,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,UAAU;AACZ;;AAEA;EACE,6FAA6F;AAC/F;;AAEA,8CAA8C;AAC9C;EACE,UAAU;AACZ;;AAEA;EACE,6FAA6F;AAC/F;;AAEA,uBAAuB;AACvB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);\n  border-top: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);\n  border-right: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);\n  border-bottom: var(--progress-item-border-width, 2px) solid transparent;\n  border-left: var(--progress-item-border-width, 2px) solid transparent;\n}\n\n.indicator {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: var(--progress-item-border-width, 2px) solid transparent;\n  border-top: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);\n  border-right: var(--progress-item-border-width, 2px) solid var(--progress-item-indicator, #d64000);\n  animation: spin var(--progress-item-animation-duration, 1s) linear infinite;\n  opacity: 0;\n}\n\n/* Default variant - only shows background circle */\n.default .indicator {\n  opacity: 0;\n}\n\n.default .background {\n  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);\n}\n\n/* Active variant - shows spinning indicator */\n.active .indicator {\n  opacity: 1;\n}\n\n.active .background {\n  border: var(--progress-item-border-width, 2px) solid var(--progress-item-background, #cccccc);\n}\n\n/* Spinning animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ex1yJN`,
	"background": `fpTWqp`,
	"indicator": `plhPZ9`,
	"spin": `Y6Urqr`,
	"default": `fHy1hz`,
	"active": `OT5R1V`
};
module.exports = ___CSS_LOADER_EXPORT___;
